import { render, staticRenderFns } from "./EditNewsletterArticleModal.vue?vue&type=template&id=0a79253f&scoped=true&"
import script from "./EditNewsletterArticleModal.vue?vue&type=script&lang=js&"
export * from "./EditNewsletterArticleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a79253f",
  null
  
)

export default component.exports